import { render, staticRenderFns } from "./exhibition-product-feedback.vue?vue&type=template&id=018b4c61&scoped=true&"
import script from "./exhibition-product-feedback.vue?vue&type=script&lang=js&"
export * from "./exhibition-product-feedback.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-product-feedback.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./exhibition-product-feedback.vue?vue&type=style&index=1&id=018b4c61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018b4c61",
  null
  
)

export default component.exports